<template>
  <div class="admin">
    <UserTable />
  </div>
</template>

<script>
// @ is an alias to /src
import UserTable from '@/components/Admin/DataTables/UserTable.vue'

export default {
  name: 'Admin',
  components: {
    UserTable
  }
}
</script>